import React from 'react';
import FormFieldTextarea from '../../FormFieldTextarea';

import { Form, Col, InputGroup } from 'react-bootstrap';
import '../../../../../css/form.css';
import '../../../../../css/call_report_form.css';

/**
 * CallReportFormFieldTextarea
 *
 * Specific configuration attribute : none
 */
class CallReportFormFieldTextarea extends FormFieldTextarea {

  /**
   * Main render method for React Component
   */
  render() {
    return (
      <Col className="container-form-field container-form-field-call-report">
        <InputGroup className={`container-form-row container-form-row-colored col-12${(!this.props.disabled && this.isValid())?" is-valid":""}${(!this.props.disabled && this.isInvalid())?" is-invalid":""}`}>
          <InputGroup.Prepend
            className="d-flex col-auto container-form-prepend">
            <InputGroup.Text
              id={`form-${this.props.formKey}-${this.props.fieldKey}`}
              className="col-md-12">
              {this.props.icons?this.props.icons.map((icon, i) => {
                return (
                  <i key={i} className={`icon-${icon}`}/>
                )
              }):undefined}
            </InputGroup.Text>
          </InputGroup.Prepend>
          {this.displayMiddlePart()}
          <Form.Control
            ref={this.inputRef}
            className="d-flex col-border-radius col-md-border-radius"
            placeholder={(typeof this.props.label === "string")?this.props.label:""}
            aria-label={this.props.label}
            aria-describedby={`form-${this.props.formKey}-${this.props.fieldKey}`}
            type="text"
            as="textarea"
            disabled={this.props.disabled || this.props.submitting}
            value={this.getValue()}
            onChange={(event) => this.onChange(event.target.value)}
            isValid={(this.props.disabled)?null:this.isValid()}
            isInvalid={(this.props.disabled)?null:this.isInvalid()}
          />
          {this.displayValidating()}
        </InputGroup>
        {this.displayValidValidators()}
        {this.displayInvalidValidators()}
      </Col>
    );
  }
}

export default CallReportFormFieldTextarea;
